import React from 'react';
import PropTypes from 'prop-types';

const SvgComponent = ({ fill, ...props }) => (
  <svg viewBox="0 0 24 24" { ...props }>
    <style />
    <path
      d="M12 4H8.89l3.31-2.17a1 1 0 0 0 .29-1.38 1 1 0 0 0-1.38-.29l-7.64 5 7.64 5c.17.11.36.16.55.16.33 0 .65-.16.84-.45a1 1 0 0 0-.29-1.38L8.39 6H12c4.41 0 8 3.59 8 8s-3.59 8-8 8-8-3.59-8-8c0-.55-.45-1-1-1s-1 .45-1 1c0 5.51 4.49 10 10 10s10-4.49 10-10S17.51 4 12 4z"
      fill={ fill }
    />
  </svg>
);

SvgComponent.propTypes = {
  fill: PropTypes.string.isRequired
};

export default SvgComponent;
